
<!-- 版权关联管理 -->
<template>
  <div>
    <el-dialog width="80%" title="版权关联管理" :visible.sync="dialogVisible" showClose append-to-body center >
      <cs-form class="header-search-box" label-width="90px" form-width="100%" :form="searchParams"
      :formData="searchData"
      :form-col="searchFormCol"
      :inline="true">
      <template slot="search">
        <el-button type="primary" @click="searchHandle()">查询</el-button>
      </template>
    </cs-form>
    <cs-table ref="tableProgram" :tableCols="tableCols" :tableData="tableData"  :paginationOption="pageOption"
        @size-change="sizeChangeHandler"
        @current-change="currentPageHandler">
      <template slot-scope="scope" slot="control">
        <el-button size="mini" @click="boundHandle(scope.row)">绑定</el-button>
      </template>
    </cs-table>
    </el-dialog>
  </div>
</template>
<script>
import { fetchCopyrights } from '@/resource/api/index'
export default {
  name: 'CopyRightManage',
  data () {
    return {
      dialogVisible: false,
      searchParams: {
        limit: 20,
        offset: 1,
        filmName: '',
        director: '',
        tostar: '',
        copyRightName: '',
        dataFlag: 0
      },
      searchFormCol: { gutter: 10, sm: 12, md: 8, lg: 6 },
      tableData: [],
      tableCols: [
        { prop: 'filmId', label: '片单关联Id' },
        { prop: 'filmName', label: '片单名称' },
        { prop: 'tostar', label: '主演' },
        { prop: 'director', label: '导演' },
        { prop: 'authRegion', label: '授权范围' },
        { prop: 'timeOfProduct', label: '出品年代' },
        { prop: 'classify', label: '分类' },
        { prop: 'copyrightName', label: '版权名称' },
        { prop: 'startTime', label: '版权开始时间' },
        { prop: 'endTime', label: '版权结束时间' },
        { prop: 'control', label: '操作', type: 'slot' }
      ],
      pageOption: {} // 节目发布分页参数
    }
  },
  methods: {
    open () {
      this.dialogVisible = true // 打开弹出框
      this.searchParams.limit = this.$store.state.pageLimit
      this.pageOption['page-size'] = this.$store.state.pageLimit
      this.currentPageHandler(1)
    },
    searchHandle () {
      this.currentPageHandler(1)
    },
    currentPageHandler (val) {
      this.searchParams.offset = val
      this.getData(this.searchParams)
    },
    sizeChangeHandler (val) {
      this.searchParams.limit = val
      this.searchParams.offset = 1
      this.getData(this.searchParams)
    },
    boundHandle (row) {
      const data = {
        filmId: row.filmId,
        copyrightName: row.copyrightName,
        copyrightCode: '请务必点击确定提交编目修改，编码将自动生成',
        startTime: row.startTime,
        endTime: row.endTime
      }
      this.$confirm('此操作将绑定此版权, 是否继续?', '绑定提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dialogVisible = false
        this.$emit('boundSuccess', data)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消绑定'
        })
      })
    },
    // 加载数据
    getData (data) {
      var that = this
      fetchCopyrights(data).then((res) => {
        if (res.code == '1') {
          res.results.forEach(item => {
            if (item.startTime || item.endTime) {
              item.startTime = that.$moment(item.startTime).format('YYYY-MM-DD')
              item.endTime = that.$moment(item.endTime).format('YYYY-MM-DD')
            }
          })
          that.tableData = res.results
          that.pageOption = {
            ...that.pageOption,
            'current-page': that.searchParams.offset,
            total: parseInt(res.total)
          }
        }
      })
    }
  },
  computed: {
    searchData () {
      return [
        {
          prop: 'filmName',
          type: 'input',
          label: '片单名称:',
          placeholder: '请输入片单名称',
          clearable: false,
          labelWidth: '90px',
          col: [3, 3, 3]
        },
        {
          prop: 'director',
          type: 'input',
          label: '导演:',
          placeholder: '请输入导演',
          clearable: false,
          labelWidth: '90px',
          col: [3, 3, 3]
        },
        {
          prop: 'tostar',
          type: 'input',
          label: '演员:',
          placeholder: '请输入演员',
          clearable: false,
          labelWidth: '90px',
          col: [3, 3, 3]
        },
        {
          prop: 'copyRightName',
          type: 'input',
          label: '版权名称:',
          placeholder: '请输入版权名称',
          clearable: false,
          labelWidth: '90px',
          col: [3, 3, 3]
        },
        { prop: 'search', type: 'slot' }
      ]
    }
  }
}
</script>
